import React from 'react';
import styled from '@emotion/styled';
import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
  tooltipClasses,
  styled as MuiStyled
} from '@mui/material';

interface CostumMuiTooltipProps extends MuiTooltipProps {
  noWrap?: boolean;
  transparent?: boolean;
}

export type TooltipProps = CostumMuiTooltipProps;

/**
 *
 * Tooltips display informative text when users hover over, focus on, or tap an element.
 *
 * You can read Material-UI Tooltip Documentation [here](https://mui.com/material-ui/api/Tooltip/).
 *
 * ```typescript
 *  import { Tooltip } from '@rabex-kit/core';
 *  ```
 *
 * @param props
 * @returns
 */

const MuiTooltipStyled: React.FC<MuiTooltipProps> = MuiStyled(MuiTooltip, {
  name: 'MuiTooltip',
  shouldForwardProp: prop => !['noWrap'].includes(prop as string)
})<MuiTooltipProps>(() => ({}));

// tooltip popper hasn't permission for wrap text
const NoMaxWidthTooltip: React.FC<TooltipProps> = styled(
  ({ className, ...props }: TooltipProps) => (
    <MuiTooltipStyled {...props} classes={{ popper: className }} />
  )
)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none'
  }
});

const Tooltip: React.FC<TooltipProps> = props => {
  return props.noWrap ? (
    <NoMaxWidthTooltip {...props} />
  ) : (
    <MuiTooltipStyled {...props} />
  );
};

export default Tooltip;

Tooltip.defaultProps = {
  transparent: false,
  placement: 'bottom-start'
};
